import {useEffect, useState} from 'react';
import api from '../../../services/api'

const useTocsBookId = (book_id) => {
    const [tocsData, setTocsData]   = useState([]);
    const [totalCnt, setTotalCnt]   = useState(0);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!book_id || isNaN(book_id)) {
            setTocsData([]);
            setTotalCnt(0);
            setIsLoading(false); // 로딩 상태 종료
            return;
        }

        const getTocs = async () => {
            try {
                const response = await api.get(`/get_tocs_with_psnorders_by_book_id/${book_id}`);
                if (response.status === 200) {
                    const items = response.data.data.map((item) => ({
                        toc_id: item.toc_id,
                        book_id: item.book_id,
                        toc_title: item.toc_title,
                        toc_title_ko: item.toc_title_ko,
                        orders: item.orders ? item.orders.map(order => ({
                            psnorders_id: order.psnorders_id,
                            book_id: order.book_id,
                            person_id: order.person_id,
                            personname: order.personname,
                            status_text: order.status_text,
                            order_text: order.order_text
                        })) : [],
                    }));

                    setTocsData(items);
                    setTotalCnt(items.length);
                }
            } catch (error) {
                console.error("Failed to fetch TOC data:", error); // 에러 로깅
                setTocsData([]);
                setTotalCnt(0);
            } finally {
                setIsLoading(false); // 로딩 상태 종료
            }
        };

        getTocs();
    }, [book_id]);

    return {tocsData, totalCnt, isLoading}
};

export default useTocsBookId;
